<template>
	<a
		:href="discussionUrl"
		target="_blank"
		v-if="store.currentComment"
		class="px-3 h-9 relative rounded-full border border-white flex justify-center items-center hover:bg-red hover:border-red !cursor-pointer text-white"
	>
		{{ commentText }}
	</a>
</template>

<script setup>
import { onMounted, defineProps, computed } from 'vue'
import { useRoute } from 'vue-router'
import { usePodcastStore } from '../stores/podcastStore'

const store = usePodcastStore()
const route = useRoute()

const props = defineProps({
	episode: {
		type: Object,
		required: true
	}
})

const discussionUrl = computed(() => {
	const comment = store.currentComment
	if (!comment || !comment.attributes) return '#'
	
	return `${store.forumUrl}/d/${comment.attributes.slug}`
})

const commentText = computed(() => {
	const comment = store.currentComment
	
	if (!comment || !comment.attributes) {
		return 'Kommentera'
	}

	const count = comment.attributes.commentCount-1

	if (count === 0) {
		return 'Kommentera'
	} else if (count === 1) {
		return '1 kommentar'
	} else {
		return `${count} kommentarer`
	}
})

onMounted(async () => {
	const podcastId = route.params.podcastId
	await store.fetchComments(`https://www.radionoden.se/podcasts/${podcastId}/episode/${props.episode.linkid}`)
})

</script>
